module.exports = __webpack_public_path__ + "static/media/Screen Shot 2020-04-17 at 12.24.31 PM.785d822c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/testimonials/social/Screen Shot 2020-04-17 at 12.24.31 PM.png
// module id = 385
// module chunks = 0